import { get } from 'lodash';
import {
    setCartProductCount,
    setCartType,
    setConsumptionCartList,
    setInventoryWishlistId,
} from '../reducers/inventoryCoreReducer.js';
import {
    fetchConsumptionCart,
    fetchInventoryWishlistId,
} from '../services/inventoryCoreService.js';

const handleError = (error) => {
    console.log('An error happened, please pass it to the global error handler', error);
    console.error('An error happened, please pass it to the global error handler', error);
    throw Error('An error happened');
};

export const getInventoryWishlistId = () => {
    return (dispatch) => {
        return fetchInventoryWishlistId()
            .then((res) => {
                dispatch(setInventoryWishlistId(res[0].wishListId));
            })
            .catch(handleError.bind(dispatch));
    };
};

export const setConsumptionCartResponse = (res) => {
    return (dispatch) => {
        if (!res) {
            throw new Error('Missing required data for Consumption Summary cart items.');
        }

        dispatch(setConsumptionCartList(res?.entries || []));
        dispatch(setCartProductCount(res?.productCount || 0));
        dispatch(setCartType(res?.type || ''));
    };
};

export const getConsumptionCart = () => {
    return (dispatch, getState) => {
        const wishListId = get(getState(), 'inventoryCoreReducer.wishListId', '');

        if (!wishListId) {
            return dispatch(getInventoryWishlistId())
                .then(() => dispatch(getConsumptionCart()))
                .catch(handleError.bind(dispatch));
        }

        return fetchConsumptionCart(wishListId)
            .then((res) => {
                res?.entries?.forEach((item) => {
                    item.replenishQuantity = item.entryQty || 0;
                });

                dispatch(setConsumptionCartResponse(res));
            })
            .catch(handleError.bind(dispatch));
    };
};

export const hasInventoryCartType = (inventoryCartType) => {
    const validCartTypes = ['KE', 'KE_KB'];
    const showCartIcon = validCartTypes?.includes(inventoryCartType);

    return showCartIcon;
};
